<template>
  <view-container
    class="view-product-register-coproducer"
    title="Coproduções"
    subtitle="Visualize todas as suas coproduções por produto"
    :breadcrumbs="breadcrumbs"
    header
  >
    <register-coproducer-step-01
      :form="form"
      :errors="errors"
      :loading="loading"
      @next="next()"
      @submit="onSubmit()"
    />
  </view-container>
</template>
<script>
import RegisterCoproducerStep01 from "@/components/product/coproducer/RegisterCoproducerStep01.vue";
import { formFields } from "@/functions/helpers";
import moment from "moment";
import { mapState } from "vuex";

export default {
  components: {
    RegisterCoproducerStep01
  },
  data() {
    return {
      loading: false,
      ...formFields(
        [
          "email",
          "qty_months",
          "tax_product",
          "payment_recurrence",
          "contract_time"
        ],
        {
          accepted_terms: false,
          payment_recurrence: true,
          contract_time: null,
          qty_months: null
        }
      )
    };
  },
  computed: {
    ...mapState("product", ["product"]),
    breadcrumbs() {
      return [
        {
          link: "tools",
          title: "Ferramentas"
        },
        {
          link: "tools-coproductions",
          title: "Coproduções"
        },
        {
          title: "Cadastrar Coprodutor"
        }
      ];
    }
  },
  methods: {
    async submitCoProducer() {
      return this.$store
        .dispatch("user/postCoProducer", this.form.email)
        .catch(error => {
          this.errors = error.response.data;
        });
    },
    async submitCoProducerProduct(co_producer_id) {
      const { payment_recurrence, tax_product, email } = this.form;
      const contract_time =
        this.form.qty_months === -1
          ? null
          : moment()
              .add(this.form.qty_months, "months")
              .format("YYYY-MM-DD");

      return this.$store.dispatch("user/postCoProducerProduct", {
        co_producer_id,
        product_id: this.$route.params.id,
        contract_time,
        payment_recurrence,
        tax_product
      });
    },
    async onSubmit() {
      this.loading = true;
      try {
        const { data: coproducer } = await this.submitCoProducer();

        await this.submitCoProducerProduct(coproducer.id);

        this.$message.success("Coprodutor cadastrado com sucesso!");

        this.$router.push({
          name: "product-coproducers",
          params: {
            id: this.$route.params.id
          }
        });
      } catch (error) {
        if (error.response && error.response.data) {
          this.errors = error.response.data;

          if (error.response.data.message) {
            this.$message.error(error.response.data.message);
            return;
          }

          let msg = "";
          for (const key in error.response.data) {
            msg += error.response.data[key].join(" ");
          }
          this.$message.error(msg);
        } else {
          this.$message.error("Não foi possível cadastrar o coprodutor");
        }
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>
<style lang="scss" scoped>
@import "@/assets/scss/_variables.scss";

.view-product-register-coproducer {
  h4 {
    font-size: 24px !important;
  }
}
</style>
